export { default } from '@esentai/core/features/receipts/api';
